export { default } from './request-equipment-service-dealer-info';
